module.exports = __webpack_public_path__ + "honor-03.jpg?bcbd462bf17a5aaf63370f8ca0bcaa84";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wap/honor-03.jpg
// module id = 181
// module chunks = 0